import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';

let alreadyHandling = false;

// Called when an authenticated request comes back 401 (unauthenticated) or 419
// (session/CSRF token expired) — i.e. the server-side session is gone while the
// user is still sitting inside the app. Instead of leaving them stuck with a
// half-broken UI (some parts silently failing), send them to the login page.
//
// Only fires when we currently believe we're logged in — a 401 while already a
// guest is normal and handled by the login/page-status flow. A hard navigation
// (not react-router) is intentional: it guarantees a clean re-bootstrap with
// `user === null`, discarding any stale in-memory auth state.
export function handleSessionExpired() {
  if (alreadyHandling) return;
  if (!getBootstrapData().user) return;
  alreadyHandling = true;
  window.location.assign(`${window.location.origin}/login?error=session_expired`);
}
